// Handle cookies
window.setCookie = function (name, value, daysToLive) {
  // Encode value in order to escape semicolons, commas, and whitespace
  let cookie = name + "=" + encodeURIComponent(value);

  // set cookie with expiration if  or default to a session cookie
  if (
    daysToLive !== false &&
    typeof daysToLive === "number" &&
    !isNaN(daysToLive)
  ) {
    let maxAge = daysToLive * 24 * 60 * 60;

    cookie += "; max-age=" + maxAge + ";path=/;SameSite=Lax";
    document.cookie = cookie;
  } else {
    cookie += "; path=/;SameSite=Lax";
    document.cookie = cookie;
  }
};

window.getCookie = function (name) {
  // Split cookie string and get all individual name=value pairs in an array
  let cookieArr = document.cookie.split(";");

  // Loop through the array elements
  for (let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
     and compare it with the given string */
    if (name == cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
};

window.removeCookie = function (name, value) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

//https://www.includehelp.com/code-snippets/how-to-create-hash-from-string-in-javascript.aspx
window.generateHash = function (string) {
  var hash = 0;

  if (string.length == 0) return hash;

  for (let i = 0; i < string.length; i++) {
    var charCode = string.charCodeAt(i);
    hash = (hash << 7) - hash + charCode;
    hash = hash & hash;
  }
  return hash;
};
